import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { CHEER_UP_GUIDE_1, CHEER_UP_GUIDE_2, CHEER_UP_GUIDE_3, CHEER_UP_TITLE } from '@constants/text';

function CheerUp(): ReactElement {
  return (
    <Layout>
      <Divider margin={20} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{ width: '172px', height: '130px' }} yzTypeCol="center">
          <img alt="cheerupImg" src={`${process.env.PUBLIC_URL}/img/cheer4x.webp`} width="172px" />
        </Col>
      </Row>
      <Divider margin={5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{CHEER_UP_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={4} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CHEER_UP_GUIDE_1}</TypographyText>
        </Col>
      </Row>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CHEER_UP_GUIDE_2}</TypographyText>
        </Col>
      </Row>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CHEER_UP_GUIDE_3}</TypographyText>
        </Col>
      </Row>
    </Layout>
  );
}

export default CheerUp;
